import axios from '@/plugins/axios'

export default {
    getAllLogs(query) {
        let { limit = 5 , page = 1 } = query
        return axios({
            url: '/optimize-logs',
            method: 'get',
            params: {
                page,
                limit
            }
        })
    },
    startOptimize() {
        return axios({
            url: '/optimize-logs/start-optimize',
            method: 'post'
        })
    },
    getLogDetail(data) {
        let { id = 0 } = data
        return axios({
            url: `/optimize-logs/detail/${id}`,
            method: 'get'
        })
    }
}
